import { useEffect, useState } from "react";
import { MessageCircle, ArrowRight } from "lucide-react";
import { WA_URL, REGISTRATION_URL } from "./data";

export const Overlays = () => {
    const [showSticky, setShowSticky] = useState(false);
    useEffect(() => {
        const onScroll = () => setShowSticky(window.scrollY > window.innerHeight * 0.85);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <>
            <a href={WA_URL} target="_blank" rel="noopener noreferrer" aria-label="Chat WhatsApp Cici Developer"
                data-testid="floating-whatsapp"
                className={`fixed right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_8px_28px_rgba(37,211,102,0.45)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_36px_rgba(37,211,102,0.6)] ${showSticky ? "bottom-24 lg:bottom-6" : "bottom-6"}`}>
                <MessageCircle className="h-7 w-7" strokeWidth={1.75} />
            </a>
            <div data-testid="sticky-mobile-cta"
                className={`fixed inset-x-0 bottom-0 z-40 border-t border-[#DDB56C]/25 bg-[#071B37]/95 px-5 py-3 backdrop-blur-xl transition-transform duration-300 lg:hidden ${showSticky ? "translate-y-0" : "translate-y-full"}`}>
                <div className="flex items-center justify-between gap-3">
                    <div>
                        <p className="text-[10px] uppercase tracking-wider text-[#DDB56C]">Early Bird</p>
                        <p className="text-base font-extrabold text-white">Rp169.000 <span className="text-xs font-normal text-white/45 line-through">Rp229.000</span></p>
                    </div>
                    <a href={REGISTRATION_URL} target="_blank" rel="noopener noreferrer" data-testid="sticky-mobile-cta-button"
                        className="inline-flex items-center gap-1.5 rounded-full bg-[#DDB56C] px-6 py-3 text-sm font-bold text-[#071B37]">
                        Daftar Sekarang <ArrowRight className="h-4 w-4" strokeWidth={2.5} />
                    </a>
                </div>
            </div>
        </>
    );
};
